import type React from "react";

interface Props {
  size?: number;
  color?: string;
}

export function BadCardIcon(props: Props): React.ReactNode {
  const { size = 20, color = "black", ...rest } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <title>Bad Card</title>
      <g id="layer1" transform="translate(-88.455583,-125.03785)">
        <g
          id="g25"
          transform="matrix(2.6287523,0,0,2.6287523,-143.31374,-200.83235)"
        >
          <path
            stroke={color}
            fill="none"
            strokeWidth={0.5}
            strokeDasharray="none"
            d="m 94.936324,127.45527 c 0.264174,-0.24856 0.515217,-0.59434 0.418062,-0.95705 -1.72e-4,-0.73341 -0.594675,-1.32791 -1.328084,-1.32808 -0.632645,0.002 -1.176193,0.44963 -1.299145,1.07022"
            id="path6"
          />
          <circle
            stroke={color}
            fill="none"
            strokeWidth={0.5}
            strokeDasharray="none"
            id="path1-4"
            cy="129.16367"
            cx="89.886002"
            r="0.54116011"
          />
          <path
            d="m 94.936324,127.45527 a 1.3283921,1.3283921 0 0 1 -0.910022,0.37155 1.3283921,1.3283921 0 0 1 -1.328601,-1.3286 1.3283921,1.3283921 0 0 1 0.02946,-0.25786 H 89.28964 c -0.388989,0 -0.701766,0.31329 -0.701766,0.70228 v 2.72076 c 0,0.38899 0.312777,0.70229 0.701766,0.70229 h 4.944401 c 0.38899,0 0.702283,-0.3133 0.702283,-0.70229 z"
            stroke={color}
            fill="none"
            strokeWidth={0.5}
            strokeDasharray="none"
            id="path7"
          />
          <path
            stroke={color}
            fill="none"
            strokeWidth={0.5}
            strokeDasharray="none"
            d="m 88.529199,127.07087 h 4.242143"
            id="path2"
          />
          <path
            stroke={color}
            fill="none"
            strokeWidth={0.5}
            strokeDasharray="none"
            d="m 88.602501,127.81707 h 5.287166"
            id="path2-2"
          />
          <path
            stroke={color}
            fill="none"
            strokeWidth={0.5}
            strokeDasharray="none"
            d="M 91.955352,129.54785 H 93.30118"
            id="path4"
          />
          <path
            stroke={color}
            fill="none"
            strokeWidth={0.5}
            strokeDasharray="none"
            d="m 93.759336,129.55263 h 0.510429"
            id="path5"
          />
          <path
            stroke="none"
            fill={color}
            strokeDasharray="none"
            d="m 93.802792,125.79112 0.0415,0.84811 0.374385,8e-5 0.04151,-0.85503 z"
            id="path8"
          />
          <path
            stroke="none"
            fill={color}
            strokeWidth={0.5}
            strokeDasharray="none"
            d="m 93.837232,126.92513 10e-7,0.30468 h 0.398956 v -0.3116 z"
            id="path9"
          />
        </g>
      </g>
    </svg>
  );
}
